import { render, staticRenderFns } from "./ExportSpecialist.vue?vue&type=template&id=b60de254"
import script from "./ExportSpecialist.vue?vue&type=script&lang=js"
export * from "./ExportSpecialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports